import { createSelector } from 'reselect'

export const notificationMessageState = (state) => state.notificationMessage

export const notificationMessageSelector = createSelector(
  notificationMessageState,
  (state) => state
)
